import { lazy } from 'react';

export const HealthCheck = lazy(() => import('./HealthCheck.component'));
